import React from "react";
import Chip from "@mui/material/Chip";

interface LabeledChipProps {
    label: string;
    color: string;
    background: string;
  }
  
  const LabeledChip = ({label, color, background}: LabeledChipProps) => 
    <div style={{ display: 'flex', justifyContent: 'center', marginTop: '15px' }}>
      <Chip
        sx={{ backgroundColor: background, color }}
        key={`chip-${label}`}
        variant="filled"
        label={label}
      />
    </div>

export default LabeledChip;
